import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/styles'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'

import { ExToolbar, ExTable } from './components'

import { compose } from 'redux'
import { connect } from 'react-redux'
import { actionListReviewProduct, actionHideReviewProduct } from '../../store/actions/reviewProduct'

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  }
}))

const ReviewProduct = ({
  reviewProduct,
  hideReviewProduct,
  dispatchListReviewProduct,
  dispatchHideReviewProduct
}) => {
  var delay = null
  const classes = useStyles()
  const [onState, setOnState] = useState(true)
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [star, setStar] = useState('')
  const [isShow, setIsShow] = useState('')
  const [search, setSearch] = useState('')
  const [limit, setLimit] = useState(10)
  const [page, setPage] = useState(1)
  const [pages, setPages] = useState(1)
  const [reviews, setReviews] = useState([])

  useEffect(() => {
    if (onState) {
      dispatchListReviewProduct(page, limit, search, startDate, endDate, star, isShow)
    }
  }, [dispatchListReviewProduct, onState, page, limit, search, startDate, endDate, star, isShow])

  useEffect(() => {
    if (reviewProduct.payload) {
      setReviews(reviewProduct.payload)
      setPage(reviewProduct.page)
      setPages(reviewProduct.pages)
      setOnState(false)
    }
  }, [reviewProduct.payload, reviewProduct.page, reviewProduct.pages])

  const handlePageChange = (event, page) => {
    setPage(page + 1)
    setOnState(true)
  }

  const handleRowsPerPageChange = event => {
    setPage(1)
    setLimit(event.target.value)
    setOnState(true)
  }

  const handleSearch = (event) => {
    const terms = event.target.value
    if (delay) clearTimeout(delay)

    if (!reviewProduct.loading) {
      delay = setTimeout(() => {
        setSearch(terms)
        setPage(1)
        setOnState(true)
      }, 600)
    }
  }

  const handleChangeStar = (event) => {
    setStar(event.target.value)
    setPage(1)
    setOnState(true)
  }

  const handleChangeIsShow = (event) => {
    setIsShow(event.target.value)
    setPage(1)
    setOnState(true)
  }

  useEffect(() => {
    if (hideReviewProduct.success) {
      setOnState(true)
    }
  }, [hideReviewProduct.success])

  const handleHideData = (id) => {
    dispatchHideReviewProduct(id)
  }

  const handleChangeStartDate = (value) => {
    if (endDate && endDate < value) {
      setEndDate(value)
      setStartDate(value)
      setOnState(true)
      return
    }

    setStartDate(value)
    setOnState(true)
  }

  const handleChangeEndDate = (value) => {
    if (startDate && startDate > value) {
      setStartDate(value)
      setEndDate(value)
      setOnState(true)
      return
    }

    setEndDate(value)
    setOnState(true)
  }

  const handleClearDate = () => {
    setStartDate(null)
    setEndDate(null)
    setStar('')
    setIsShow('')
    setOnState(true)
  }

  return (
    <div className={classes.root}>
      <ExToolbar 
        onSearch={handleSearch} 
        startDate={startDate}
        endDate={endDate}
        star={star}
        isShow={isShow}
        onChangeStar={handleChangeStar}
        onChangeIsShow={handleChangeIsShow}
        onChangeStartDate={handleChangeStartDate}
        onChangeEndDate={handleChangeEndDate}
        onClearDate={handleClearDate}
      />

      <div className={classes.content}>
        <ExTable 
          reviews={reviews}
          page={page} 
          pages={pages} 
          limit={limit}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handleRowsPerPageChange}
          onHideData={handleHideData}
        />
      </div>
    </div>
  )
}

ReviewProduct.propTypes = {
  history: PropTypes.object
}

const mapStateToProps = (state) => {
  return {
    reviewProduct: {
      loading: state.reviewProduct.listReviewProduct.loading,
      page: state.reviewProduct.listReviewProduct.page,
      pages: state.reviewProduct.listReviewProduct.pages,
      stars: state.reviewProduct.listReviewProduct.stars,
      payload: state.reviewProduct.listReviewProduct.payload
    },
    hideReviewProduct: {
      success: state.reviewProduct.hideReviewProduct.success
    }
  }
}

const mapDispatchToProps = (dispatch) => { 
  return {
    dispatchListReviewProduct: (page, limit, search, startDate, endDate, star, isShow) => dispatch(actionListReviewProduct(page, limit, search, startDate, endDate, star, isShow)),
    dispatchHideReviewProduct: (reviewId) => dispatch(actionHideReviewProduct(reviewId))
  }
}


export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(ReviewProduct)
